export default {
  API_URL: 'https://pxgroup-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://pxgroupsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
